import {Column} from "material-table";
import {BaseDocument} from "../dms/definitions/BaseDocument";
import {FormatTypes} from "../core/Formater";
import {string} from "prop-types";
import * as React from "react";

export type FilterComponent<RowData extends object> = (props: {
	columnDef: Column<RowData>;
	onFilterChanged: (rowId: string, value: any) => void;
}) => React.ReactElement<any>;

export class ColumnData<RowData extends object> implements Column<RowData> {
    id: string | number;
	constructor (title: string, field: keyof RowData, lookup?: object, documentField?: string, format?: FormatTypes, filterComponent?: FilterComponent<RowData>, cellStyle?: any, customFilterAndSearch?: any ) {
		this.title = title;
		this.field = field;
		this.lookup = lookup;
		this.documentField = documentField
		this.format = format
		this.filterComponent = filterComponent
		this.cellStyle = cellStyle
		this.customFilterAndSearch = customFilterAndSearch
	}

	title ?: string
	field ?: keyof RowData | keyof BaseDocument;
	documentField?: string
	format?: FormatTypes
	defaultSort?: ('asc' | 'desc');
	defaultFilter?: any;
	tableData?: any;
	lookup?: object;
	filterComponent: FilterComponent<RowData>;
	cellStyle?: any
	customFilterAndSearch?: any
}
